module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_gc-021f0e9b615373d595fe55029eb95ce7.gif";